export default "__VITE_ASSET__BeyhHIjJ__"